import { DateListDataPoint, Visualization } from '@vyce/core/src/types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/** Maps text_list visualization rows to date-list style points for FormSummaryTime / FormSummaryDate. */
export const visualizationTextListToDateListPoints = (visualization: Visualization): DateListDataPoint[] => {
  if (visualization.type !== 'text_list') return [];

  return visualization.data
    .map((item, index) => {
      const raw =
        typeof (item as any)?.value === 'string' ? (item as any).value : (item as any)?.value?.text ?? null;

      const value = typeof raw === 'string' ? raw : null;
      if (!value) return null;

      return { index, value, count: 1, percentage: 0 };
    })
    .filter(Boolean) as DateListDataPoint[];
};

export const parseFormDate = (value: string) => dayjs(value, 'YYYY-MM-DD', true);

export const formatFormDateLabel = (value: string) => {
  const parsedDate = parseFormDate(value);
  return parsedDate.isValid() ? parsedDate.format('D MMMM YYYY') : value;
};

export const parseFormTime = (value: string) => dayjs(value, 'HH:mm', true);

export const formatFormTimeLabel = (value: string) => {
  const parsedTime = parseFormTime(value);
  return parsedTime.isValid() ? parsedTime.format('h.mm A') : value;
};
